var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"mt-4",attrs:{"sm":"3","md":"3"}},[_c('div',{staticClass:"content-center border stat-card"},[_c('h4',{staticClass:"bg-lighter stat-text pt-3 pb-3"},[_vm._v(_vm._s(_vm.title))]),_c('h1',{staticClass:"mt-4 mb-3 stat-title"},[_c('b-icon',{attrs:{"icon":_vm.icon_name}}),_c('br'),_vm._v(" "+_vm._s(_vm.number)+" ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }